<template>
	<div id="controleFontes">
		<a-row type="flex" justify="space-between" align="bottom">
			<a-col :span="5">
				<a-row>
					<span>Tribunal:</span>
				</a-row>
				<a-row>
					<a-input
						style="width: 95%;"
						placeholder="Tribunal"
						v-model="valueTribunal"			
						@change="onChangeTribunal"						
						:disabled="loading"			
						>					
					</a-input>
				</a-row>
			</a-col>
			<a-col :span="5">
				<a-row>
					<span>Usuário:</span>
				</a-row>
				<a-row>
					<a-input
						style="width: 95%;"
						placeholder="Usuário"
						v-model="valueUsuario"		
						@change="onChangeUsuario"						
						:disabled="loading"	
						>					
					</a-input>
				</a-row>
			</a-col>
			<a-col :span="3">
				<a-row>
					<span>Status:</span>
				</a-row>
				<a-select
					style="width: 95%;"
					@change="onChangeStatus"
					:value="valueStatus"
					:disabled="loading"
					:allowClear="valueStatus!='3'"
					>
					<a-select-option value="3">Todos</a-select-option>
					<a-select-option value="1">Ativo</a-select-option>
					<a-select-option value="0">Inativo</a-select-option>
				</a-select>
			</a-col>

			<a-col :span="3">
				<a-row>
					<span class="tr-label" >Inicial:</span>
				</a-row>
				<a-row>
					<a-date-picker
						@change="onChangeDataIncial"
						placeholder="Data Incial"
						style="width: 95%;"
						:format="dateFormat"
						:disabled="loading"
					/>
				</a-row>
			</a-col>
			<a-col :span="3">
				<a-row>
					<span class="tr-label">Final:</span>
				</a-row>
				<a-row>
					<a-date-picker
						@change="onChangeDataFinal"
						placeholder="Data Final"
						style="width: 95%;"
						:format="dateFormat"
						:disabled="loading"
					/>
				</a-row>
			</a-col>
			
			<a-col :span="3" style="text-align: right;">
				<a-button
					class="tr-search-btn"
					type="primary"
					@click.stop.prevent="carregarControleFontes()"
					:disabled="loading"
				>Pesquisar</a-button>
			</a-col>
		</a-row>

		<a-row style="height: calc(100vh - 230px); overflow-y: auto; overflow-x: auto; min-height: 100px;">
			<a-table
				:columns="columns"
				:rowKey="record => record.idCliente"
				:dataSource="data"
				:loading="{spinning:loading, tip:'Carregando...'}"
				:pagination="pagination"
				@change="handleTableChange"
				size="middle"
			>
				<template slot="ativa" slot-scope="ativa, record">					
					<a-icon type="check-circle" class="sucess" v-if="record.ativa"/>
					<a-icon type="close-circle" class="danger" v-else/>					
				</template>
				<template
					slot="dataAlteracao"
					slot-scope="dataAlteracao, record"
				>{{formatarDataLocal(record.dataAlteracao, true, 'DD/MM/YYYY HH:mm:ss')}}</template>
			</a-table>
			<a-row type="flex" align="bottom">
					<a-button
						class="btnExcel"
						type="primary"
						icon="file-excel"
						size="default"
						@click.stop.prevent="exportarExcel"
					></a-button>
			</a-row>
		</a-row>
	</div>
</template>

<script>
import PortalCredencialWebApi from "@/API/PortalCredencialWebApi";
import ModalComponent from "@/components/ModalComponent";
import moment from "moment";
import { showNotificationError } from "@/util/showNotification";
import { showNotificationSucess } from "@/util/showNotification";
import Helpers from "@/util/Helpers";

const columns = [
	{
		title: "Tribunal",
		dataIndex: "tribunal",
		sorter: (a, b) => a.tribunal.localeCompare(b.tribunal),		
		scopedSlots: { customRender: "tribunal" }
	},
	{
		title: "Usuário Alteração",
		dataIndex: "usuario",
		sorter: (a, b) => a.usuarioAlteracao.localeCompare(b.usuarioAlteracao),
		scopedSlots: { customRender: "usuario" }
	},
	{
		title: "Qtd Acesso diario",
		dataIndex: "limite",
		sorter: (a, b) => a.limite.localeCompare(b.limite),
		scopedSlots: { customRender: "limite" }
	},
	{
		title: "Data Alteração",
		dataIndex: "dataAlteracao",
		sorter: (a, b) => a.dataAlteracao.localeCompare(b.dataAlteracao),
		width: "15%",
		scopedSlots: { customRender: "dataAlteracao" }
	},
	{
		title: "Situação",
		dataIndex: "ativa",
		sorter: (a, b) => a.ativa - b.ativa,		
		align: "center",
		scopedSlots: { customRender: "ativa" }
	}
];

export default {	
	name: "controleFontes",
	data() {
		return {
			idTela: 3,
			data: [],
			pagination: {},
			loading: false,
			dateFormat: "DD/MM/YYYY",
			columns,
			filter:{
				tribunal: '',
				usuario: '',
				dataInicial: '',
				dataFinal: '',
				ativa: "3",
				idUsuario: null,
				idPerfil: null
			},
			valueUsuario: '',
			valueTribunal: '',
			valueStatus: '3',
			valueDataInicial: null,
			valueDataFinal: null,
			selectedRowKeys: [],
		};
	},
	mounted() {    
		// this.carregarControleFontes();       
	},
	methods: {
		carregarControleFontes() {
			if (!this.validarFiltro()){
				return;
			}
			
			this.filter.idUsuario = this.$store.state.auth.idUser
			this.filter.idPerfil = this.$store.state.auth.idPerfilPortal
			this.loading = true;
			PortalCredencialWebApi.getcarregarControleFontes(this.filter).then(res => {
				this.loading = false;
				if (res.data.statusCode != 200) {
					showNotificationError(this, "Relatório Controle de Fontes", res.data.errorMessage);
					return;
				} else if (typeof res.data.result == "string") {
					showNotificationSucess(this, "Relatório Controle de Fontes", res.data.result);
				} else {
					this.data = res.data.result;
					this.pagination = { current: 1 };
				}
			})
			.catch(res => {
				this.loading = false;
				showNotificationError(this, "Relatório Controle de Fontes", "Erro ao tentar carregar lista de fonte monitoradas.");
			});
			
		},
		async exportarExcel() {
			PortalCredencialWebApi.exportarRelatorioControleFonte(this.filter)
				.then(res => {
					this.loading = false;
					let arrayValidacao = [null, "undefined", ""]
					let data = res.data;					
					if (!arrayValidacao.includes(data)) {
						let blob = new Blob([res.data], {
							type: "application/vnd.ms-excel"
						});
						let link = document.createElement("a");
						link.href = window.URL.createObjectURL(blob);						
						link.download = "Relatório_Controle_Fontes" + new Date().toLocaleDateString() + ".xlsx";
						document.body.appendChild(link);
						link.click();
						document.body.removeChild(link);
					} else {
						showNotificationError(this, "Relatório Controle Fontes", "Erro ao tentar gerar arquivo.");
					}
				})
				.catch(res => {
					this.loading = false;
					showNotificationError(this, "Relatório Controle Fontes", "Erro ao tentar gerar arquivo.");
				});
		},
		handleTableChange(pagination, filters, sorter) {
			const pager = { ...this.pagination };
      		pager.current = pagination.current;
      		this.pagination = pager;
		},
		onChangeUsuario() {	
			this.filter.usuario = this.valueUsuario == '' ? null : this.valueUsuario;
		},
		onChangeTribunal() {
			this.filter.tribunal = this.valueTribunal == '' ? null : this.valueTribunal;
		},
		onChangeStatus(value) {
			this.valueStatus = value == undefined ? '3' : value;
			this.filter.ativa = this.valueStatus == '3' ? null : this.valueStatus;
		},
		onChangeDataIncial(date, dateString) {
			this.valueDataInicial = dateString == '' ? null : date;
			this.filter.dataInicial = this.valueDataInicial == '' ? null : this.valueDataInicial;
		},
		onChangeDataFinal(date, dateString) {
			this.valueDataFinal = dateString == '' ? null : date;
			this.filter.dataFinal = this.valueDataFinal == '' ? null : this.valueDataFinal;

		},
		formatarDataLocal(data, isDateTime, format) {
			return Helpers.formatarData(data, isDateTime, format);
		},
		validarFiltro() {
			let diff = moment(this.filter.dataFinal, "DD/MM/YYYY").diff(moment(this.filter.dataInicial, "DD/MM/YYYY"));

			if (moment.duration(diff)._data.days < 0)
			{
				showNotificationError(this, "Relatório Controle de Fontes", "Data Final não pode ser menor do que a Data Inicial.");
				return false;
			}
			if (moment.duration(diff)._data.months >= 1 || moment.duration(diff)._data.years >= 1)
			{
				showNotificationError(this, "Relatório Controle de Fontes", "Período não pode ser maior do que 30 dias.");
				return false;
			}
			if (this.valueDataInicial == null || this.valueDataFinal == null){
				showNotificationError(this, "Relatório Processo", "Data Inicial e Final é um campo Obrigatório!");
				return false;
			}

			return true;
		}
	},    
};
</script>

<style scoped>
span {
	color: #000;
	font-family: "Segoe UI", "Segoe UI Emoji", "Segoe UI Symbol", "Courier New",
		Courier, monospace;
	font-weight: bold;
}

div .ant-row-flex {
	margin-top: 5px;
	margin-bottom: 10px;
}

.content {
  height: 100%;
}

.ant-layout {
  height: 100%;
  background: "#fff";
}

.ant-layout-content {
  height: 100%;
  background: #fff;
}

.ant-layout-footer {
  position: absolute;
  bottom: 0;
  width: 100%;
}
 
.cursor {
  cursor: pointer;
}

.cursor:hover {
  color: blue;
}

.danger {
	color: red;
}

.sucess {
	color: green;
}

.config-form-button {
	width: 100px;
}

.tr-ant-select {
	margin: 10px 0px 10px 0px;
} 
.btnExcel {
	text-align: 'center';
	position: 'relative'; 
	width: 45px;
	height: 45px;
	font-size: 24px;
	font-weight: bold;
	cursor: pointer;
	border-radius: 50%;
}
.btnExcel:hover {
	background-color: #0755A4;
	transition: all 0.3s ease-in;
}
</style>

<style>
</style>